import Enum from "../../../../../enums/Enum";

const BillTypeEnum = new Enum({
        DIRECT_BILLING: {name: "DB"},
        SELF_PAY: {name: "SP"}
});

export default BillTypeEnum;